<template>
  <div class="container">
    <div class="head header">
      <img src="@/assets/back.png"
           style="margin: 10px"
           alt="返回"
           width="21"
           height="21"
           @click="go">
      <div class="box">新增地址</div>
      <!-- <img src="@/assets/delete.png" style="margin: 10px" width="24" height="24"/> -->
    </div>
    <div class="addhint">新增收货地址</div>
    <div class="row">
      <div class="title">
        <div class="xing">*</div>
        <div class="name">收货人</div>
      </div>
      <input class="value"
             v-model="userAddr.name"
             placeholder="请输入收货人名称" />
    </div>
    <div class="row">
      <div class="title">
        <div class="xing">*</div>
        <div class="name">手机号码</div>
      </div>
      <input class="value"
             v-model="userAddr.tel"
             maxlength="11"
             onkeyup="value=value.replace(/[^\d]/g,'')"
             placeholder="请输入手机号码" />
    </div>
    <div class="row">
      <div class="title">
        <div class="xing">*</div>
        <div class="name">配送地址</div>
      </div>
      <div class="optaddress"
           @click="show = true">
        <div class="deaddress">{{userAddr.address||'请选择(省/市/区)'}}</div>
        <div class="deadd">
          <img src="@/assets/addgo.png" alt="" width="14px" height="14px">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="title">
        <div class="xing">*</div>
        <div class="name">详细地址</div>
      </div>
      <input class="value"
             v-model="userAddr.detail"
             placeholder="请输入详细地址"/>
    </div>
    <div class="row">
      <div class="title">
        <div class="name"
             style="margin-bottom: 15px">邮政编码</div>
      </div>
      <input class="value"
             v-model="userAddr.postCode"
             placeholder="请输入邮政编码" />
    </div>
    <van-cell center
              title="设置为默认地址"
              style="margin-top: 33px">
      <template #right-icon>
        <van-switch v-model="userAddr.isDefault"
                    size="24"
                    active-color="red"
                    inactive-color="#C9C9C9" />
      </template>
    </van-cell>
    <div class="save"
         @click="_saveShopAddress">保存</div>
    <selectAddress :show="show"
                   @confirmAddr="confirmAddr"
                   @cancelAddr="cancelAddr"></selectAddress>

  </div>

</template>

<script>
import selectAddress from './selectAddress.vue'
import { saveShopAddress } from '../../api/address/index.js'
export default {
  name: 'Edit',
  data () {
    return {
      show: false,
      addressInfo: {
        province: '',
        city: '',
        area: ''
      },
      userAddr: {
        uid: '',
        name: null,
        tel: null,
        address: null,
        detail: null,
        postCode: null,
        isDefault: true
      }
    }
  },
  components: {
    selectAddress
  },
  methods: {
    go () {
      this.$router.go(-1)
    },
    // 确定选择地址
    confirmAddr (e) {
      e.forEach((item, index) => {
        if (index === 0) {
          this.addressInfo.province = item.name
        } else if (index === 1) {
          this.addressInfo.city = item.name
        } else if (index === 2) {
          this.addressInfo.area = item.name
        }
      })
      this.userAddr.address = this.addressInfo.province + this.addressInfo.city + this.addressInfo.area
      this.show = false
    },
    // 取消选择地址
    cancelAddr () {
      this.show = false
    },
    // 新增地址
    _saveShopAddress () {
      let params = JSON.parse(JSON.stringify(this.userAddr))
      var user = localStorage.getItem("userInfo")
      user = JSON.parse(user)
      params.uid = user.id
      if (!this.userAddr.name) {
        this.$toast.fail('收货人不能为空')
        return
      }
      if (!this.userAddr.tel) {
        this.$toast.fail('手机号码不能为空')
        return
      }
      if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.userAddr.tel))){
        this.$toast.fail("手机号码有误，请重填");
        return;
      }
      if (!this.userAddr.address) {
        this.$toast.fail('配送地址不能为空')
        return
      }
      if (!this.userAddr.detail) {
        this.$toast.fail('详细地址不能为空')
        return
      }
      saveShopAddress(params).then((res) => {
        if (res.success) {
          this.$toast.success('添加成功!')
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000)
        } else {
          this.$toast.fail('失败')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
::-webkit-input-placeholder {
  color: #ccc;
}
.container {
  .box {
    display: flex;
    flex: 1;
    justify-content: center;
  }
  .head {
    background-color: #f3f3f3;
    height: 44px;
    line-height: 44px;
    opacity: 1;
    display: flex;
    justify-content: space-between;
  }
  .addhint {
    padding: 10px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 22px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
  }
  .row {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    .title {
      display: flex;
      padding-left: 15px;
      .xing {
        font-size: 30px;
        color: red;
      }
      .name {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 21px;
        color: rgba(153, 153, 153, 1);
        opacity: 1;
        margin-left: 6px;
      }
    }
    .optaddress {
      width: 90%;
      height: 40px;
      display: flex;
      justify-content: space-between;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      opacity: 1;
      border-radius: 4px;
      line-height: 40px;
      margin-left: 2%;
      padding-left: 20px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      .deaddress {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
      }
      .deadd {
        color: #c9c9c9;
        font-size: 20px;
      }
    }
    .value {
      width: 90%;
      height: 40px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      opacity: 1;
      border-radius: 4px;
      margin-left: 2%;
      padding-left: 20px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  .van-cell:not(:last-child)::after {
    border: none;
  }
  .save {
    width: 95%;
    height: 40px;
    background: linear-gradient(
      0deg,
      rgba(244, 4, 66, 1) 0%,
      rgba(226, 23, 75, 0.73) 100%
    );
    opacity: 1;
    border-radius: 4px;
    margin-left: 2%;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-top: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/address/add.vue